// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"52013f32","668":"8918fae9","756":"57ee4d34","838":"b04f42ea"}[chunkId] + ".js";
};